import { render } from "./tags-list-detail.vue?vue&type=template&id=3eb03e03"
import script from "./tags-list-detail.vue?vue&type=script&lang=js"
export * from "./tags-list-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__